// extracted by mini-css-extract-plugin
module.exports = {"powerkitpresale":"PowerKitPreSale_powerkitpresale__zoB4V"};